import React from "react";
import { Skills } from "../../Data/Data";

const Skill = () => {
  return (
    <section className="experience" id="Skills">
      <h2>What i do</h2>
      <div className="experience__inner">
        <div className="inner__data">
          <div className="title">
            {Skills.Icons.Tools}
            <h3>Tools</h3>
          </div>
          <div className="tools">
            {Skills.Tools.map(({ icon, name }) => (
              <div className="item">
                <div className="icon" aria-label="hidden">
                  {icon}
                </div>
                <p>{name}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="inner__data">
          <div className="title">
            {Skills.Icons.Tech}
            <h3>Technologies</h3>
          </div>
          <div className="technologies">
            {Skills.Technologies.map(({ icon, name }) => (
              <div className="item">
                <div className="icon">{icon}</div>
                <p>{name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skill;
